import { useEffect, useRef } from "react";
import StructuredView from "./StructuredView";

// Ported from ai-medical-consultation-assistant/src/components/WorkspacePanel.jsx
// The "Transcript" header + Raw/Revised/Structured tabs are lifted up into the
// panel's top bar (next to the mic button) to save vertical space — the active
// tab now comes in as a prop.
export default function WorkspacePanel({
  tab = "structured",
  rawLines,
  revisedLines,
  propositions,
  onEditPropositionItem,
  onAddPropositionItem,
  onAddAllPropositions,
  revisedTranscript,
  onAddTranscript,
}) {
  const scrollRef = useRef(null);
  const activeLines = tab === "raw" ? rawLines : tab === "revised" ? revisedLines : null;

  useEffect(() => {
    if (tab === "structured") return;
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [activeLines, tab]);

  return (
    <div className="panel workspace-panel">
      <div className="workspace-scroll" ref={scrollRef}>
        {tab === "structured" ? (
          <StructuredView
            propositions={propositions}
            onEditItem={onEditPropositionItem}
            onAddItem={onAddPropositionItem}
            onAddAll={onAddAllPropositions}
            revisedTranscript={revisedTranscript}
            onAddTranscript={onAddTranscript}
          />
        ) : activeLines.length === 0 ? (
          <p className="empty-state">
            {tab === "raw"
              ? "La transcription brute apparaîtra ici dès le premier extrait audio traité."
              : "La transcription révisée apparaîtra ici après l'analyse du premier extrait."}
          </p>
        ) : (
          activeLines.map((line, i) => (
            <div
              key={i}
              className={`transcript-line transcript-line--${
                line.speaker === "Doctor" ? "doctor" : "patient"
              }`}
            >
              <span className="transcript-line__speaker">{line.speaker}</span>
              <span className="transcript-line__text">{line.text}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
